import { render, staticRenderFns } from "./Humons.vue?vue&type=template&id=18413016&"
import script from "./Humons.vue?vue&type=script&lang=js&"
export * from "./Humons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports